<!--
 * @Author: zhaoliang
 * @Date: 2023-02-27 14:43:35
 * @LastEditTime: 2026-03-09 15:22:22
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Login/index.vue
 *
-->
<template>
  <div :class="['login-module', $i18n.locale === 'fr_CA' ? 'login-box-bgfr' : 'login-box-bgen']">
    <div class="login-box" :style="{ minHeight: minHeight }">
      <div class="login-box-layout">
        <div class="login-box-help" v-if="step !== 4">
          <img
            src="~img/help.png"
            alt="help"
            v-if="!showTips"
            @click="
              () => {
                this.showTips = !this.showTips;
              }
            "
          />
          <div class="login-box-close" v-if="showTips">
            <img
              src="~img/close.png"
              alt="close"
              @click="
                () => {
                  this.showTips = !this.showTips;
                }
              "
            />
          </div>
          <div class="login-help" v-if="showTips">
            <h1>{{ $i18n.t('tips-title') }}</h1>
            <template v-if="step === 1">
              <p v-for="(item, index) in step1TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <!-- {{ $i18n.t(item.description) }} -->
                <i18n-t v-if="item.linktext" :keypath="item.description" tag="span">
                  <a
                    :href="$i18n.locale === 'fr_CA' ? item.frurl : item.enurl"
                    target="_blank"
                    style="cursor: pointer; text-decoration: underline"
                  >
                    {{ $i18n.t(item.linktext) }}
                  </a>
                </i18n-t>
                <span v-else>{{ $i18n.t(item.description) }}</span>
              </p>
            </template>
            <!-- 新设备 -->
            <template v-if="step === 2 && mfaDetail.isNewDevice === 0">
              <p v-for="(item, index) in step2TipsConfig1" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
            <!-- 信任设备并开启otp -->
            <template v-if="step === 2 && mfaDetail.isNewDevice === 1">
              <p v-for="(item, index) in step2TipsConfig2" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
            <template v-if="step === 3">
              <p v-for="(item, index) in step3TipsConfig" :key="index">
                <span>{{ $i18n.t(item.title) }}</span>
                <br />
                <span>
                  {{ $i18n.t(item.description) }}
                </span>
              </p>
            </template>
          </div>
        </div>
        <div class="login-box-help" v-else></div>
        <div v-if="step === 1" class="login-step1">
          <div class="login-box-title">
            {{ $i18n.t('login') }}
          </div>
          <div class="login-box-form">
            <div class="login-form">
              <!-- login 邮件输入框 -->
              <div class="login-email-group">
                <div class="form-item-label">
                  <label for="email">{{ $i18n.t('login-account-label') }}*</label>
                </div>
                <div class="email-input-img">
                  <SafeInput
                    id="email"
                    :className="{ 'login-form-item item-email': true, 'input-border-err': infoErr }"
                    :type="showEmail"
                    name="email"
                    :placeholder="$i18n.t('login-account-placeholder')"
                    autocomplete="off"
                    role="input email"
                    v-model.trim="formData.username"
                    @keyup.enter="handleLogin"
                    @input="handleValueChange($event)"
                  />
                  <img
                    v-show="showEm"
                    class="eye"
                    src="~img/icon-feather-eye-off.svg"
                    @click="emailStatus('password')"
                    alt="hide email"
                  />
                  <img
                    v-show="!showEm"
                    class="eye"
                    src="~img/icon-feather-eye-on.svg"
                    @click="emailStatus('text')"
                    alt="show email"
                  />
                </div>
              </div>
              <!-- login 密码输入框 -->
              <div class="login-password-group">
                <div class="form-item-label">
                  <label for="password">{{ $i18n.t('login-password') }}*</label>
                </div>
                <div class="password-input-img">
                  <input
                    id="password"
                    class="login-form-item item-password fs-mask"
                    :class="{ 'input-border-err': infoErr }"
                    :type="showPassword"
                    name="password"
                    :placeholder="$i18n.t('login-password')"
                    autocomplete="off"
                    role="input password"
                    v-model="formData.password"
                    @keyup.enter="handleLogin"
                  />
                  <img
                    v-show="showPd"
                    class="eye"
                    src="~img/icon-feather-eye-off.svg"
                    @click="passwordStatus('password')"
                    alt="hide password"
                  />
                  <img
                    v-show="!showPd"
                    class="eye"
                    src="~img/icon-feather-eye-on.svg"
                    @click="passwordStatus('text')"
                    alt="show password"
                  />
                </div>
              </div>
              <!-- login 错误提示 -->
              <p v-if="infoErr" class="error-message">{{ errorMsg }}</p>
            </div>
          </div>
          <div class="login-box-button">
            <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
              <!-- <div v-if="!loading" @click="handleLogin" role="button"> -->
              <div v-if="!loading" @click="checkBeforeLogin" role="button">
                <img src="~img/icon-lock.svg" alt="lock" />
                <span>{{ $i18n.t('login') }}</span>
              </div>
              <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
            </div>
            <a class="forget-password" role="link" @click="forgetPassword">
              {{ $i18n.t('login-forgot') }}
            </a>
            <span class="login-line"></span>
          </div>
          <div class="login-box-bottom">
            <button class="sign-up" role="button sign up" @click="handleLinkClick('/sign-up')">
              <span class="new-user">{{ $i18n.t('user') }}</span>
              {{ $i18n.t('signup') }}
            </button>
          </div>
        </div>
        <div v-if="step === 2" class="login-step2">
          <Captcha
            ref="captcha"
            @handleResend="handleResend"
            @handleDone="handleDone"
            @handleFinish="handleFinish"
            :loading="loading"
            :errMsg="errCaptchaMsg"
            :bottomline="canChangeAuthtype"
          >
            <template #title>
              <img src="~img/icon-lock-black.svg" alt="lock" />
              <span>{{ $i18n.t('code-auth-title') }}</span>
            </template>
            <!-- Subtitle Start -->
            <!-- otp提示语 -->
            <template #subtitle v-if="securitySubtitle && !noSubtitle">
              {{ $i18n.t('code-auth-subtitle1') }}
            </template>
            <!-- 新设备提示语 -->
            <template #subtitle v-else-if="newDeviceSubtitle && !noSubtitle">
              {{ $i18n.t('code-auth-subtitle2') }}
            </template>
            <!-- Subtitle End -->
            <!-- Desc Start -->
            <template #desc v-if="!needLoginAgain">
              {{ $i18n.t('code-auth-desc1') }}
            </template>
            <!-- needLoginAgain表示从reset页面跳转过来的, 此时流程为重置密码，所以提示语为 "A code has been sent to xxx" -->
            <template #desc v-else>{{ $i18n.t('code-auth-desc2') }}</template>
            <!-- Desc End -->
            <template #info>{{ captchaInfo }}</template>
            <template #other v-if="!needLoginAgain">{{ $i18n.t('code-auth-info') }}</template>
          </Captcha>
          <div v-if="canChangeAuthtype">
            <div class="login-code-bottom" v-if="authType === 2" @click="changeAuthType(1)">
              <img
                class="email-logo"
                src="@/components/LeftAccount/images/icon-email.svg"
                alt="email logo"
              />
              <span class="login-code-toemail">{{ $i18n.t('code-auth-toemail') }}</span>
            </div>
            <div class="login-code-bottom" v-if="authType === 1" @click="changeAuthType(2)">
              <img
                class="phone-logo"
                src="@/components/LeftAccount/images/icon-phone.svg"
                alt="phone logo"
              />
              <span class="login-code-toemail">{{ $i18n.t('code-auth-tophone') }}</span>
            </div>
          </div>
        </div>
        <div v-if="step === 3" class="login-step3">
          <ForceResetPsw
            ref="forceResetPsw"
            @handleSave="handleSave"
            :loading="loading"
            :errMsg.sync="errPasswordMsg"
          >
            <!-- needLoginAgain表示从reset页面跳转过来的 -->
            <template #title>{{ $i18n.t('mbs-new-password') }}</template>
            <template #subtitle v-if="!needLoginAgain">
              {{ $i18n.t('forgetpsw-subtitle') }}
            </template>
            <template #desc v-if="!needLoginAgain">{{ $i18n.t('forgetpsw-desc1') }}</template>
            <template #desc v-else>{{ $i18n.t('forgetpsw-desc2') }}</template>
          </ForceResetPsw>
        </div>
        <div v-if="step === 4" class="login-step4">
          <ForgetPsw
            @handleSend="handleSendCodeToEmail"
            :loading="loading"
            :errEmailMsg.sync="errEmailMsg"
          ></ForgetPsw>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '@/router';
  import store from '@/store';
  import verify from '@/utils/verify';
  import Captcha from './Captcha.vue';
  import ForceResetPsw from './ForceResetPsw.vue';
  import ForgetPsw from './ForgetPsw.vue';
  import { v4 as uuid } from 'uuid';
  import { getEmailBeforeAt, getFirst4andLast2Num } from '@/utils';
  import {
    step1TipsConfig,
    step2TipsConfig1,
    step2TipsConfig2,
    step3TipsConfig,
  } from './tipsConfig.js';
  import SafeInput from '@/components/SafeInput/index.vue';
  // 非响应式数据不需要放在data中，提升性能
  const deviceName = JSON.parse(localStorage.getItem('currentDeviceName'));
  export default {
    name: 'LoginModal',
    components: { Captcha, ForceResetPsw, ForgetPsw, SafeInput },
    props: {
      minHeight: {
        type: String,
        default: '0px',
      },
    },
    mounted() {
      if (this.$route.query.type === 'forget') {
        sessionStorage.removeItem('userContactToken');
        this.forgetPassword();
      }
    },
    data() {
      return {
        step: 1, // 1：登录  2: 验证码 3: 修改密码 4:忘记密码
        step1TipsConfig,
        step2TipsConfig1,
        step2TipsConfig2,
        step3TipsConfig,
        infoErr: false,
        loading: false,
        formData: {
          username: '',
          password: '',
          version: '1.0.0',
          device: 'web',
          deviceName,
        },
        loginDisable: true,
        showPassword: 'password',
        showEmail: 'text',
        showTips: false,
        errorMsg: '',
        errCaptchaMsg: '',
        errPasswordMsg: '',
        errEmailMsg: '',
        mfaDetail: {
          callPrefix: '',
          phone: '',
          email: '',
          isNewDevice: 1, // 是否为新设备   0 是 1 否
        },
        authType: 1, // 1-邮件 2-手机
        authKey: '',
        loginOtpToken: '',
        canChangeAuthtype: true,
        isChecked: false, // 三星手机自带浏览器的自动登录功能会跳过check接口
        needLoginAgain: false,
        newDeviceSubtitle: false,
        securitySubtitle: false,
        noSubtitle: false,
      };
    },
    computed: {
      showEm() {
        if (this.showEmail === 'password') {
          return true;
        }
        return false;
      },
      showPd() {
        if (this.showPassword === 'password') {
          return true;
        }
        return false;
      },
      desensitizedPhone() {
        const { callPrefix, phone } = this.mfaDetail;
        const phEx = `+${callPrefix}`;
        const newPhone = phone.indexOf(phEx) !== -1 ? phone.slice(phEx.length) : phone;
        return phone ? `${phEx} ${getFirst4andLast2Num(newPhone)}` : '';
      },
      desensitizedEmail() {
        const { email } = this.mfaDetail;
        return email ? getEmailBeforeAt(email) : '';
      },
      captchaInfo() {
        return this.authType === 1 ? this.desensitizedEmail : this.desensitizedPhone;
      },
    },
    watch: {
      formData: {
        handler(newVal) {
          if (newVal.username && newVal.password) {
            this.loginDisable = false;
          } else {
            this.loginDisable = true;
          }
          if (newVal.username) {
            this.infoErr = false;
            this.errorMsg = '';
          }
          if (newVal.password) {
            this.infoErr = false;
            this.errorMsg = '';
          }
        },
        deep: true,
      },
    },

    methods: {
      passwordStatus(data) {
        this.showPassword = data === 'password' ? 'text' : 'password';
      },
      emailStatus(data) {
        this.showEmail = data === 'password' ? 'text' : 'password';
      },
      forgetPassword() {
        this.needLoginAgain = true;
        this.step = 4;
      },
      checkBeforeLogin() {
        if (this.loginDisable) return;
        verify({ username: this.formData.username }).then(errMsg => {
          if (errMsg.pass) {
            const deviceId = localStorage.getItem('deviceId') || uuid();
            localStorage.setItem('deviceId', deviceId);
            const data = {
              userName: this.formData.username,
              password: this.formData.password,
              deviceId,
              loginCheckType: 2,
              lang: this.$i18n.locale,
            };
            this.$http.login.checkBeforeLogin(data).then(res => {
              if (res.state === '11') {
                this.isChecked = true;
                this.mfaDetail = res.payload;
                this.authKey = res.payload.key;
                this.loginOtpToken = res.payload.loginOtpToken || '';
                sessionStorage.setItem('userContactToken', res.payload.userContactToken);
                const { needChangePassword, isNeedOpt, authType, checkInfo, isNewDevice } =
                  res.payload;
                // (已经认证手机或邮箱在陌生设备登录  或者 已经认证手机邮箱且开启OTP，在陌生设备登录)checkinfo != 0   needotp =true  newdevices =0     提示语 Looks like you’re logging in xxxx
                if (checkInfo !== 0 && isNeedOpt && isNewDevice === 0) {
                  this.newDeviceSubtitle = true;
                }
                // (旧用户或刚注册的用户)check info = 0   need otp =true  new devices =0     提示语 for your security xxxx
                if (checkInfo === 0 && isNeedOpt && isNewDevice === 0) {
                  this.securitySubtitle = true;
                }
                // (已经认证手机邮箱且开启OTP，在信任设备登录)check info == 3   need otp =true  new devices =1     提示语 无小标题
                if (checkInfo === 3 && isNeedOpt && isNewDevice === 1) {
                  this.noSubtitle = true;
                }
                if (needChangePassword && isNeedOpt) {
                  // 验证手机或者邮箱之后，强制改密码
                  this.authType = authType;
                  this.sendAuthCode(authType, () => {
                    this.step = 2;
                    this.canChangeAuthtype = true;
                  });
                }
                if (needChangePassword && !isNeedOpt) {
                  // 强制修改密码,但是不需要验证手机或者邮箱
                  this.step = 3;
                }
                if (!needChangePassword && isNeedOpt) {
                  this.authType = authType;
                  this.sendAuthCode(authType, () => {
                    this.step = 2;
                    this.canChangeAuthtype = true;
                  });
                }
                if (!needChangePassword && !isNeedOpt) {
                  // 直接登录
                  this.handleLogin();
                }
              } else {
                this.infoErr = true;
                this.errorMsg = res.note;
              }
            });
          } else {
            this.infoErr = true;
            this.errorMsg = errMsg[0].errMessage;
          }
        });
      },
      handleLogin() {
        if (this.loginDisable) return;
        if (!this.isChecked) {
          this.checkBeforeLogin();
          return;
        }
        verify({ username: this.formData.username }).then(errMsg => {
          if (errMsg.pass) {
            const deviceId = localStorage.getItem('deviceId') || uuid();
            localStorage.setItem('deviceId', deviceId);
            store
              .dispatch('loginModule/login', {
                ...this.formData,
                loginOtpToken: this.loginOtpToken,
                lang: this.$i18n.locale,
                deviceId,
              })
              .then(res => {
                if (res.state === '11') {
                  localStorage.setItem('needGetMarketingNotice', '1');
                  const afterLoginRouter = sessionStorage.getItem('afterLoginRouter');
                  if (afterLoginRouter) {
                    router.push(afterLoginRouter);
                    sessionStorage.removeItem('afterLoginRouter');
                  } else if (
                    router.currentRoute.value.name === 'SignUp' ||
                    router.currentRoute.value.name === 'Login'
                  ) {
                    router.push('/');
                  }
                  const { ingenicoType } = res.user;
                  /* 登录时 ingenicoType === 2 登录成功 */
                  /* 登录时 ingenicoType === 0 重新验证用户已绑定的卡 获取前6的接口 补全卡号  web端没有该逻辑，忽略，算登录成功 */
                  /* ingenicoType === 1 验证新的卡 */
                  if (ingenicoType === 1) {
                    // 跳转至update页面，并且此时保持未登录状态
                    this.$store.commit('setState', {
                      state: 'isIngenicoUpdatePending',
                      values: true,
                    });
                    this.$messageModal.show({
                      image: false,
                      closeIcon: false,
                      title: 'update-tip-title',
                      desc: 'update-tip-desc',
                      confirmBtn: 'OK',
                      justHide: true,
                      i18nNeed: true,
                      successCallback: () => this.$loginModal.showUpload(),
                    });
                  } else {
                    // 防止第一次触发了校验后切换其他账号时, 其他账号登录后, 校验状态还在 true, 导致刷新丢失登录信息
                    this.$store.commit('setState', {
                      state: 'isIngenicoUpdatePending',
                      values: false,
                    });
                  }

                  if (res.vcesCheckResult === 1) {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 1,
                    });
                    sessionStorage.setItem('vcesStatus', 1);
                    this.$messageModal.show({
                      image: false,
                      closeIcon: true,
                      desc: 'membershipDt',
                      confirmBtn: 'viewMemb',
                      cancelBtn: 'cancel',
                      justHide: true,
                      i18nNeed: true,
                      successCallback: () => {
                        this.$router.push('/account/membership');
                      },
                    });
                  } else if (res.vcesCheckResult === 2) {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 2,
                    });
                    sessionStorage.setItem('vcesStatus', 2);
                    this.$messageModal.show({
                      i18nNeed: true,
                      image: false,
                      desc: 'vces-check-failed',
                      confirmBtn: 'ok',
                      justHide: true,
                    });
                  } else {
                    store.commit('setState', {
                      state: 'vcesStatus',
                      values: 0,
                    });
                    sessionStorage.setItem('vcesStatus', 0);
                  }
                } else if (res.state === '00') {
                  this.infoErr = true;
                  this.errorMsg = res.note;
                }
              })
              .catch(err => {
                console.log('login err', err);
              });
          } else {
            this.infoErr = true;
            this.errorMsg = errMsg[0].errMessage;
          }
        });
      },
      handleResend(callback) {
        if (!this.captchaInfo) return;
        this.sendAuthCode(this.authType, callback);
      },
      changeAuthType(authType) {
        if (!this.captchaInfo) return;
        this.sendAuthCode(authType, () => {
          this.authType = authType;
        });
      },
      handleFinish(data) {
        console.log('finish', data);
        this.errCaptchaMsg = '';
      },
      handleDone(authCode) {
        console.log('done');
        const { email, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        const deviceId = localStorage.getItem('deviceId') || uuid();
        localStorage.setItem('deviceId', deviceId);
        let data = {};
        if (userContactToken) {
          data = {
            userId,
            lang: this.$i18n.locale,
            authType: this.authType,
            authCode,
            key: this.authKey,
            deviceId,
            userContactToken,
            checkScene: 0,
          };
        } else {
          data = {
            lang: this.$i18n.locale,
            authType: this.authType,
            authCode,
            key: this.authKey,
            email,
            deviceId,
            checkScene: 0,
          };
        }
        this.$http.account
          .checkAuthCode(data)
          .then(res => {
            if (res.state === '11') {
              const oldFlag = this.canChangeAuthtype;
              this.canChangeAuthtype = false;
              this.loginOtpToken = res.payload.loginOtpToken;
              this.$refs.captcha.showSuccess(() => {
                if (this.mfaDetail.needChangePassword) {
                  this.step = 3;
                  this.$nextTick(() => {
                    this.canChangeAuthtype = oldFlag;
                  });
                } else {
                  this.handleLogin();
                }
              });
            } else {
              if (res.errorCode === 'opt.code.error') {
                this.errCaptchaMsg = this.$i18n.t('code-auth-notmatch');
              } else if (res.errorCode === 'error.6.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-1'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-1'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.step = 1;
                  },
                });
              } else if (res.errorCode === 'auth.error.locked.30') {
                this.$messageModal.show({
                  title: this.$i18n.t('otp-errmsg-title-3'),
                  image: false,
                  closeIcon: true,
                  desc: this.$i18n.t('otp-errmsg-desc-3'),
                  confirmBtn: this.$i18n.t('ok'),
                  justHide: true,
                  successCallback: () => {
                    this.step = 1;
                  },
                });
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      handleLinkClick(path) {
        router.push(path);
      },
      resetForm() {
        this.formData = {
          username: '',
          password: '',
          version: '1.0.0',
          device: 'web',
          deviceName,
        };
        this.infoErr = false;
        this.errorMsg = '';
        this.showPassword = 'password';
      },
      handleValueChange(e) {
        const { value } = e.target;
        this.formData.username = value.replace(/\s+/g, '');
      },
      handleSave(data) {
        console.log('save new password', data);
        const { newPassword } = data;
        const params = {
          password: newPassword,
          email: this.mfaDetail.email,
          key: this.authKey,
        };
        this.$http.login.saveNewPassword(params).then(res => {
          if (res.state === '11') {
            // 重置密码成功，跳转到登录页面，让用户重新登录
            this.$refs.forceResetPsw.showSuccess(() => {
              if (this.needLoginAgain) {
                if (store.state.isLogin) {
                  store.dispatch('loginModule/logout', {
                    noJump: true,
                  });
                }
                this.step = 1;
              } else {
                this.formData.password = newPassword;
                this.handleLogin();
              }
            });
          } else {
            this.errPasswordMsg = res.note;
          }
        });
      },
      handleSendCodeToEmail(email) {
        this.mfaDetail.email = email;
        this.mfaDetail.needChangePassword = true;
        this.authType = 1;
        this.sendAuthCode(
          this.authType,
          () => {
            this.step = 2;
            this.canChangeAuthtype = false;
          },
          errorMsg => {
            this.errEmailMsg = errorMsg;
          },
        );
      },
      sendAuthCode(authType, successCallback, failCallback) {
        // this.authType = authType;
        const { email, userId } = this.mfaDetail;
        const userContactToken = sessionStorage.getItem('userContactToken');
        let data = {};
        if (userContactToken) {
          data = {
            userId,
            authType,
            lang: this.$i18n.locale,
            userContactToken,
            sendScene: 0, //  0 普通opt 1 修改手机
          };
        } else {
          data = {
            authType,
            lang: this.$i18n.locale,
            sendScene: 0, //  0 普通opt 1 修改手机
            email,
          };
        }
        this.$http.account.sendAuthCode(data).then(res => {
          if (res.state === '11') {
            // code sent
            this.authKey = res.payload.key;
            successCallback && successCallback();
          } else {
            // 错误码处理
            if (res.errorCode === 'retry.after.1.min') {
              // this.errCaptchaMsg = this.$i18n.t('otp-errmsg-desc-4');
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-4'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
              });
            } else if (res.errorCode === 'error.6.locked.30') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-3'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-3'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.step = 1;
                },
              });
            } else if (res.errorCode === 'too.many.requests') {
              this.$messageModal.show({
                title: this.$i18n.t('otp-errmsg-title-2'),
                image: false,
                closeIcon: true,
                desc: this.$i18n.t('otp-errmsg-desc-2'),
                confirmBtn: this.$i18n.t('ok'),
                justHide: true,
                successCallback: () => {
                  this.step = 1;
                },
              });
            } else {
              failCallback && failCallback(res.note);
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile.scss';
</style>
